import { createContext } from 'react';

import type { TabsContext } from 'components/Tabs/Tabs';

export const DEFAULT_TAB_CONTEXT = {
    openTabIndex: 0,
    pageContext: null,
    setOpenTabIndex: () => undefined,
    setSubTabIndex: () => undefined,
    setTabs: () => undefined,
    subTabIndex: [],
    tabs: [],
    tabsDispatch: () => undefined
};

export function createTabContext<T>() {

    return createContext<TabsContext<T>>(DEFAULT_TAB_CONTEXT);

}